import { h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";

import Emotar from "../../../apps/containers/AppContainer/HeaderContainer/UserMenuContainer/Emotars/EmotarList/Emotar";
import classname from "../../../foundation/utils/classname";

import styles from "./SidebarLoading.module.css";

interface BaseResourceLineProps {
    emotar: string;
}

interface SideResourceLineProps {
    main?: false;
    resourceName?: never;
}

interface MainResourceLineProps {
    main: true;
    resourceName: string;
}

type ResourceLineProps = BaseResourceLineProps & (SideResourceLineProps | MainResourceLineProps);

function ResourceLine({
    emotar,
    main = false,
    resourceName
}: ResourceLineProps) {
    const dotsTimeoutRef = useRef<number | undefined>();
    const [dotCount, setDotCount] = useState<number>(0);

    useEffect(() => {
        if (main) {
            dotsTimeoutRef.current = window.setInterval(() => {
                setDotCount(dc => (dc + 1) % 4);
            }, 1000);
        }

        return () => {
            window.clearInterval(dotsTimeoutRef.current);
        };
    }, [main]);

    function renderResourceContent() {
        if (main) {
            return (
                <div class={classname(styles.resourceName, "body-1")}>
                    Fetching {resourceName}{".".repeat(dotCount)}
                </div>
            );
        }

        return <div class={styles.loadingLine}/>;
    }

    return (
        <div class={styles.resourceLine}>
            <div class={styles.resourceEmotarContainer}>
                <Emotar class={main ? styles.mainResourceEmotar : styles.resourceEmotar} emotar={emotar}/>
            </div>
            {renderResourceContent()}
        </div>
    );
}

function ResourceConnector() {
    return (
        <div class={styles.resourceConnectorContainer}>
            <div class={styles.resourceConnector}/>
        </div>
    );
}

interface Props {
    class?: string;
    resourceName: string;
}

export default function SidebarLoading({ class: cssClass, resourceName }: Props) {
    return (
        <div class={classname(styles.sidebarLoading, cssClass)}>
            <ResourceLine emotar="cookie"/>
            <ResourceConnector/>
            <ResourceLine resourceName={resourceName} emotar="sunglasses" main/>
            <ResourceConnector/>
            <ResourceLine emotar="lion_face"/>
            <ResourceConnector/>
        </div>
    );
}
